<template>
  <v-row>
    <v-col
      sm="1"
      lg="2"
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs" 
            v-on="on" 
            @click="regresar"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard
        title="Detalles Aliado"
        :loading="cardLoading"
      >
        <v-row justify="center">
          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Aliado
            </p>
            <p class="text-subtitle-1">
              {{ aliado.aliado }}
            </p>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Descripción
            </p>
            <template v-if="aliado.descripcion != null">
              <p class="text-subtitle-1">
                {{ aliado.descripcion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Dirección
            </p>
            <template v-if="aliado.direccion != null">
              <p class="text-subtitle-1">
                {{ aliado.direccion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Telefono
            </p>
            <template v-if="aliado.telefono != null">
              <p class="text-subtitle-1">
                {{ aliado.telefono }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Correo Electrónico
            </p>
            <p class="text-subtitle-1">
              {{ aliado.correo }}
            </p>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Contacto Aliado
            </p>
            <template v-if="aliado.contacto_aliado != null">
              <p class="text-subtitle-1">
                {{ aliado.contacto_aliado }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Telefono Contacto Aliado
            </p>
            <template v-if="aliado.telefono_contacto_aliado != null">
              <p class="text-subtitle-1">
                {{ aliado.telefono_contacto_aliado }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Correo Electrónico Contacto Aliado
            </p>
            <template v-if="aliado.correo_contacto_aliado != null">
              <p class="text-subtitle-1">
                {{ aliado.correo_contacto_aliado }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from '../../../components/admin/DetailCard.vue'

export default {
  data: () => ({
    cardLoading: true,
    resourcesUrl: [
      "http://localhost:8000/images/aliados/logotipos/"
    ]
  }),

  components: {
    DetailCard
  },

  mounted() {
    this.$store.dispatch("obtenerAliadoCampesenaId", this.$route.params.idAliado)
    setTimeout(() => {
      this.cardLoading = false
    }, 1000)
  },

  computed: {
    aliado() {
      return this.$store.getters.obtenerAliadoCampesena;
    },
  },

  methods: {
    regresar() {
      this.$router.back()
    },
  }
};
</script>